module.exports = __webpack_public_path__ + "static/media/enlarger_front.7c4aaffe.jpg";